<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 font-bold1">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/dgin/index">Manage GIN</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Create GIN
      </h6>

      <div class="container-fluid">
        <div class="card bdr-rad2 mt-2 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="SaveGin">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label">Issued To</label>
                    <input v-model="gin.end_user" class="form-control form-control-sm bdr-rad">
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="custom-label">Issue Date</label>
                    <input type="date" v-model="gin.issues_date" class="form-control form-control-sm bdr-rad" required>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label">SO No</label>
                    <input v-model="gin.so_num" class="form-control form-control-sm bdr-rad" disabled>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label">Remarks</label>
                    <textarea v-model="gin.SI_remarks" class="form-control form-control-sm bdr-rad" rows="2"></textarea>
                  </div>
                </div>
              </div>

            <div class="card custom_bdr_rds">
        <div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>GIN Items</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead style="font-size: small;" class="background_color2">
                    <tr>
                      <th>Product Code</th>
                      <th class="text_right">Available Qty</th>
                      <th class="text_right">SO Qty</th>
                      <th class="text_right">Available GIN Qty</th>
                      <th class="text_right">GIN Qty</th>
                      <th class="action-col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in detail" :key="index">
                      <td>
                        <input
                          class="form-control form-control-sm bdr-rad product-input"
                          placeholder="SKU - Product Name"
                          v-model="item.product_display"
                          @input="updateProductFromInput(index)"
                          @blur="updateProductFromInput(index)"
                          disabled
                          required
                        >
                        <input v-model="item.inven_id" type="hidden">
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="item.available_qty"
                          class="form-control form-control-sm bdr-rad text_right"
                          disabled
                          required
                        >
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="item.so_qty"
                          class="form-control form-control-sm bdr-rad text_right"
                          disabled
                          required
                        >
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="item.available_gin_qty"
                          class="form-control form-control-sm bdr-rad text_right"
                          disabled
                          required
                        >
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="item.SD_qty"
                          class="form-control form-control-sm bdr-rad text_right"
                          min="1"
                          :max="item.available_gin_qty"
                          @input="validateGinQty(item)"
                          required
                        >
                        <small v-if="item.qty_error" class="text-danger">{{ item.qty_error }}</small>
                      </td>
                      <td class="custom-icon action-col">
                        <b-icon
                          v-if="detail.length > 1"
                          @click="remove(index)"
                          class="mr-3 mt-2"
                          type="button"
                          icon="dash-lg"
                          scale="1.4"
                        ></b-icon>
                        <b-icon
                          @click="add"
                          class="mt-2"
                          type="button"
                          icon="plus-lg"
                          scale="1.4"
                        ></b-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>

              <div class="d-flex justify-content-end mt-3">
                <button type="submit" class="mr-1 btn btn-primary btn-sm mb-1 bdr-rad">Create</button>
              </div>
              </div>
              </div>
            </form>
          </div>
        </div>
        <br><br><br>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: {
    ContentFooter,
    TopNavbar,
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      count: 0,
      gin: {},
      products: [],
      detail: [
        {
          P_code: '',
          P_description: '',
          product_display: '',
            available_qty: '',
            so_qty: '',
            available_gin_qty: '',
            inven_id: '',
          SD_qty: '',
        },
      ],
    };
  },
  mounted() {
    this.loadProduct();
    this.loadSalesOrder();
  },
  methods: {
    async SaveGin() {
      try {
        this.detail.forEach((item) => this.validateGinQty(item));
        if (this.detail.some((item) => item.qty_error)) {
          return;
        }

        const { data } = await axios.post('/dgin/create', {
          cont: this.count,
          gin: this.gin,
          details: this.detail.map((item) => ({
            so_dtl_id: item.so_dtl_id,
            id_product: item.id_product,
            so_qty: item.so_qty,
            gin_qty: item.SD_qty,
          })),
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });

        this.status = data.status;
        if (this.status == 200) {
        this.$router.push('/dgin/index');
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },

    async loadProductId(index) {
      try {
        const item = this.detail[index];
        const { data } = await axios.get('/dsales/product-availability', {
          params: {
            id: item.id_product || undefined,
            sku: item.P_code || undefined,
          },
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });

        this.detail[index].available_qty = Number(data.available_qty || 0);
        this.detail[index].id_product = data.id_product || item.id_product;
      } catch (error) {
        console.log(error.response || error);
      }
    },

    async updateProductFromInput(index) {
      const input = (this.detail[index].product_display || '').trim();
      const selectedProduct = this.products.find((product) => (
        String(product.display || '').toLowerCase() === input.toLowerCase()
        || String(product.P_code || '').toLowerCase() === input.toLowerCase()
      ));

      if (selectedProduct) {
        this.detail[index].P_code = selectedProduct.P_code;
        this.detail[index].P_description = selectedProduct.P_description || selectedProduct.name || '';
        this.detail[index].product_display = selectedProduct.display;
        await this.loadProductId(index);
      } else {
        this.detail[index].P_code = '';
        this.detail[index].P_description = '';
        this.detail[index].available_qty = '';
        this.detail[index].inven_id = '';
      }
    },

    async loadProduct() {
      try {
        const { data } = await axios.get('/istockissue/loadprodcut', {
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });

        this.products = (data.product || []).map((product) => {
          const code = product.P_code || product.sku || '';
          const description = product.P_description || product.name || '';

          return {
            ...product,
            P_code: code,
            P_description: description,
            display: code + ' - ' + description,
          };
        });
      } catch (error) {
        console.log(error.response || error);
      }
    },

    async loadSalesOrder() {
      const saleId = this.$route.query.id;
      if (!saleId) {
        return;
      }

      try {
        const { data } = await axios.get('/dsales/view?id=' + saleId, {
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });

        const sale = data.all_data || data.quatations || {};
        const details = Array.isArray(data.details) ? data.details : [];

        this.gin = {
          ...this.gin,
          so_id: sale.id || saleId,
          so_num: sale.so_num || '',
          end_user: sale.customer_name || sale.C_name || '',
          issues_date: this.gin.issues_date || new Date().toISOString().slice(0, 10),
          SI_remarks: this.gin.SI_remarks || '',
        };

        if (!details.length) {
          return;
        }

        this.detail = details.map((item) => {
          // SO Qty is the original sales-order line quantity. The available
          // GIN quantity is that value less all previously created GIN qty.
          const qty = Number(item.qty || item.SD_qty || item.so_qty || 0);
          const availableGinQty = item.gin_issued_qty !== undefined
            ? Math.max(0, qty - Number(item.gin_issued_qty || 0))
            : Number(item.gin_available_qty !== undefined
              ? item.gin_available_qty
              : qty);

          return {
            P_code: item.sku || item.P_code || '',
            P_description: item.product_name || item.P_description || '',
            product_display: (item.sku || item.P_code || '') + ' - ' + (item.product_name || item.P_description || ''),
            id_product: item.id_product || '',
            so_dtl_id: item.id || '',
            available_qty: qty,
            so_qty: qty,
            available_gin_qty: availableGinQty,
            SD_qty: availableGinQty,
            qty_error: '',
            inven_id: item.id_inventory || '',
          };
        });

        // Keep products loaded from the sales order selectable even when the
        // product lookup endpoint does not return that item.
        const loadedProductOptions = this.detail
          .filter((item) => item.P_code)
          .map((item) => ({
            P_code: item.P_code,
            P_description: item.P_description || '',
            display: item.P_code + ' - ' + (item.P_description || ''),
          }));
        const productOptions = [...this.products, ...loadedProductOptions];
        this.products = productOptions.filter((product, optionIndex, options) => (
          options.findIndex((option) => option.P_code === product.P_code) === optionIndex
        ));

        // Refresh the inventory quantity without changing SO or GIN quantities.
        await Promise.all(this.detail.map((item, index) => (
          item.P_code ? this.loadProductId(index) : Promise.resolve()
        )));
        this.count = Math.max(this.detail.length - 1, 0);
      } catch (error) {
        console.log(error.response || error);
      }
    },

    add() {
      this.count++;
      this.detail.push({
        P_code: '',
        P_description: '',
        product_display: '',
        available_qty: '',
        so_qty: '',
        available_gin_qty: '',
        inven_id: '',
        SD_qty: '',
        qty_error: '',
      });
    },

    validateGinQty(item) {
      const ginQty = Number(item.SD_qty || 0);
      const soQty = Number(item.available_gin_qty || 0);
      const availableQty = Number(item.available_qty || 0);

      if (ginQty > soQty) {
        item.qty_error = 'GIN Qty cannot exceed Available GIN Qty';
      } else if (ginQty > availableQty) {
        item.qty_error = 'GIN Qty cannot exceed Available Qty';
      } else if (ginQty < 1) {
        item.qty_error = 'GIN Qty must be at least 1';
      } else {
        item.qty_error = '';
      }
    },

    remove(index) {
      if (this.detail.length <= 1) {
        return;
      }

      this.count--;
      this.detail.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.background_color {
  background-color: #eaf6ff;
  min-height: calc(100vh - 60px);
}
.background_color2{
    color: white;
}

.manage-boder {
  background-color: #007bff;
  color: #fff;
  padding: 10px 15px !important;
  margin-bottom: 10px;
}

.decoration {
  color: #fff !important;
  text-decoration: none;
}

.font1,
.custom-label,
.gin-table {
  font-size: small;
}

.bdr-rad {
  border-radius: 12px;
}

.bdr-rad2 {
  border-radius: 12px;
}

.gin-section-title {
  background-color: #007bff;
  color: #fff;
  border-radius: 4px;
  font-size: small;
  font-weight: 700;
  padding: 6px 10px;
}

.gin-table thead th {
  background-color: #235983;
  color: #fff;
  border-bottom: 1px solid #1b3348;
  vertical-align: middle;
}

.gin-table td {
  vertical-align: middle;
}

.action-col {
  width: 80px;
  text-align: center;
}

.custom-icon {
  color: #1b3348;
  cursor: pointer;
}

.product-name {
  color: #44627c;
  display: block;
  font-size: 11px;
  margin-top: 4px;
}

.product-input {
  min-width: 250px;
}

.text_right {
  text-align: right;
}
</style>
